var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { get, map, find } from 'lodash';
import debug from 'debug';
import Vue from 'vue';
import { Memoize } from 'typescript-memoize';
const log = debug('itp:core:users');
export class Users {
    users;
    app;
    filters;
    constructor(app) {
        this.users = [];
        this.app = app;
        this.filters = userFilters(this);
    }
    registerFilters() {
        for (let [k, v] of Object.entries(this.filters)) {
            Vue.filter(k, v);
        }
    }
    getById(id) {
        return find(this.users, { id });
    }
    getUserDisplayName(id) {
        const user = this.getById(id);
        return user ? user.fullname || user.username || user.email || user.id : id;
    }
    async load() {
        const cfg = this.app.spec.config;
        if (this.app.isFakeAuth || (cfg && cfg.noLoadUsers)) {
            return Promise.resolve();
        }
        try {
            return this.app.connections
                .getConnection('default')
                .request('list_users')
                .then(result => {
                this.users = map(result.data, mapUserData);
            });
        }
        catch (error) {
            log('Failed to load users - %o', error);
        }
    }
}
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Users.prototype, "getById", null);
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Users.prototype, "getUserDisplayName", null);
function mapUserData(data) {
    const id = get(data, 'id'), email = get(data, 'email'), username = get(data, 'username'), enabled = get(data, 'enabled') || false, firstname = get(data, 'firstname'), lastname = get(data, 'lastname'), fullname = `${firstname} ${lastname}`.trim();
    return {
        id,
        email,
        username,
        enabled,
        fullname
    };
}
function userFilters(users) {
    return {
        username(value) {
            return users.getUserDisplayName(value);
        }
    };
}
//# sourceMappingURL=users.js.map